type VersionFile = {
  version: string
}

const isVersionFile = (payload: unknown): payload is VersionFile =>
  typeof payload === 'object' &&
  payload !== null &&
  typeof (payload as VersionFile).version === 'string' &&
  (payload as VersionFile).version.trim().length > 0

// The deployed version lives in a file rather than the bundle because
// `__APP_VERSION__` is frozen at build time — see the `app-version-file` plugin
// in vite.config.mts. Written on every build, uploaded with no-cache headers.
export const fetchDeployedVersion = async (url: string): Promise<string> => {
  // `no-store` bypasses the browser HTTP cache; the unique query string covers
  // any intermediate cache that ignores request headers.
  const response = await fetch(`${url}?t=${Date.now()}`, { cache: 'no-store' })
  if (!response.ok) throw `${url} responded ${response.status}`
  // CloudFront rewrites 403/404 to index.html with a 200, so a missing file
  // arrives as HTML — `json()` rejects and the caller logs it.
  const payload = await response.json()
  // Validate rather than assert: a malformed payload must surface as a failed
  // check, not as a bogus mismatch that prompts every user to refresh.
  if (!isVersionFile(payload)) throw `${url} carries no version`
  return payload.version
}
